export const getLoggedInPlatformUserId = (profile = {}) => {
  const candidates = [profile.meUserId, profile.userid, profile.id];
  for (const raw of candidates) {
    if (raw != null && String(raw).trim() !== "") {
      return String(raw).trim();
    }
  }
  return null;
};

export const isLoggedInPlatformUserId = (profile, targetUserId) => {
  const sessionId = getLoggedInPlatformUserId(profile);
  const target =
    targetUserId == null || String(targetUserId).trim() === ""
      ? null
      : String(targetUserId).trim();
  if (!sessionId || !target) {
    return false;
  }
  return sessionId === target;
};

export const reloadPageIfLoggedInUser = (profile, targetUserId) => {
  if (isLoggedInPlatformUserId(profile, targetUserId)) {
    window.location.reload();
    return true;
  }
  return false;
};
